import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import s from './index.module.scss';

import {Popover, Tabs} from 'antd';
import {spliceFirstString} from '../util';

import {http} from '../request';
import i18next from 'i18next';
import {connect} from 'react-redux';
import actions from '../../redux/action';
import {HEADER_TABS} from '../../redux/action/types';
import {RightOutlined} from '@ant-design/icons';


class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: false, loginPage: props.props.location.pathname === '/login' || false, name: '',
    };
  }

  changeLanguage() {
    let lang = this.props.locale;
    lang = lang === 'zh' ? 'en' : 'zh';
    this.props.changeLanguage(lang);
  }

  componentDidMount() {
    this.getLoginInfo();
  }

  //获取登录信息
  getLoginInfo() {
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '';
    if (userInfo && userInfo.display_name) {
      this.setState({
        isLogin: true, name: userInfo.display_name,
      });
    }
  }

  //登出
  async logout() {
    const res = await http('get', '/account/logout').catch(err => console.log(err, 'err in logout'));
    if (res?.status === 200 || (res.data && res.data.code === 0)) {
      this.setState({
        isLogin: false,
      });
      localStorage.removeItem('userInfo');
      this.props.props.history.push('/login');
    }
  }

  renderTabs = () => {
    const { isLogin } = this.state;
    if (!isLogin) {
      return null;
    }
    return <>
      <Tabs style={{marginTop: 15}}  animated={ false } activeKey={ this.props.currentTab } tabBarGutter={ 50 } onChange={ key => {
        this.props.changeHeaderTab(key);
        this.props.props.history.push(`/${ key }`);
      } }>
        <Tabs.TabPane key={ HEADER_TABS.main } tab={ i18next.t('docs') }/>
        <Tabs.TabPane key={ HEADER_TABS.privatisation } tab={ i18next.t('privatisation') }/>
      </Tabs>
    </>;
  };

  renderLanguage(locale) {
    return <Popover content={ 
    <div className={s.localePop} type={ 'text' } onClick={ () => {this.changeLanguage();} } >
      { locale.includes('zh') ? 'English': '中文' }
      </div> 
      }  trigger="hover" placement="bottom">
    <div className={s.localeInfo} type={'text'}>{ locale.includes('zh') ? '中文' : 'English' }<RightOutlined rotate={90} style={{marginLeft:'5px'}} /></div>
    </Popover>;
  }

  render() {
    const { locale } = this.props;
    const { loginPage, name, isLogin } = this.state;
    return (<div className={ s.container } id="header">
      <div className={ s.head_left }>
        <a href="https://qingping.co" target="_blank" rel="noopener noreferrer" className={ s.logo_link }>
          <div className={ s.logo_icon }/>
        </a>
        <div className={ s.logo_line }></div>
        <Link to="/" rel="noopener noreferrer" className={ s.developer_title } onClick={ () => this.props.changeHeaderTab(HEADER_TABS.none) }>
          开发者平台
        </Link>
        { this.renderTabs() }
      </div>

      { loginPage ? this.renderLanguage(locale) : (isLogin ? <div className={ s.buttonWrap }>
        <Popover content={ (<div className={ s.userTab }>
          <div className={ s.tabItem }>
            <Link to={ `/personal` }>{ i18next.t('access_information') }</Link>
          </div>
          <div className={ s.tabItem }>
            <Link to={ `/personal/helpFeedback` }>
              { i18next.t('feedback_suggestion') }
            </Link>
          </div>
          <div className={ s.tabItem } onClick={ () => this.logout() }>{ i18next.t('logout') }
          </div>
        </div>) } title="" trigger="hover" placement="bottom">
          <div className={ s.userInfo }>
            <span className={ s.userName }>{ name }</span>
            <span className={ s.userIcon }>{ spliceFirstString(name) }</span>
            {/* <DownOutlined /> */ }
          </div>
        </Popover>
        { this.renderLanguage(locale) }
      </div> : <div className={ s.loginWrap }>
        <Link to={ `/login` } className={ s.loginButton }>
          <div className={ s.login }>
            { i18next.t('login') }
          </div>
        </Link>
        { this.renderLanguage(locale) }
      </div>) }

    </div>);
  }
}


const mapStateToProps = state => ({
  locale: state.language.language, currentTab: state.header.currentTabKey,
});
const mapDispatchToProps = dispatch => ({
  changeLanguage: language => dispatch(actions.onChangeLanguage(language)),
  changeHeaderTab: tab => dispatch(actions.onChangeTab(tab)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);


